import styles from "./SortableHeader.module.css";

type SortableHeaderProps<T extends string> = {
  label: string;
  field: T;
  sortField: T | null;
  sortDirection: "asc" | "desc";
  onSort: (field: T) => void;
};

export function SortableHeader<T extends string>({
  label,
  field,
  sortField,
  sortDirection,
  onSort,
}: SortableHeaderProps<T>) {
  const isActive = sortField === field;

  return (
    <div
      className={`${styles.sortableHeader} ${isActive ? styles.sortableHeaderActive : ""}`}
      onClick={() => onSort(field)}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSort(field);
        }
      }}
    >
      <span>{label}</span>
      {isActive ? (
        <span className={styles.sortIcon}>{sortDirection === "asc" ? "↑" : "↓"}</span>
      ) : (
        <span className={styles.sortIconInactive}>↕</span>
      )}
    </div>
  );
}
